import { useDeleteContactApi } from '../api/delete-contact-api'
import { useEffect } from 'react'
import { notification } from '@/shared/helpers/notificationMessages'
import { errorHandler } from '@/shared/lib/errorHandler'
import { useTranslation } from 'react-i18next'

export const useDeleteContact = () => {
  const {
    mutateAsync,
    isPending: isLoadingDelete,
    isSuccess: isSuccessDelete,
  } = useDeleteContactApi()
  const { t } = useTranslation(['common'])

  const handleDeleteContact = async (id: number, onClose: () => void) => {
    try {
      await mutateAsync(id)
    } catch (error) {
      errorHandler(error, t('common:notification_messages.delete_contact_error'))
    } finally {
      onClose()
    }
  }

  useEffect(() => {
    if (isSuccessDelete) {
      notification.success(
        t('common:notification_titles.success'),
        t('common:notification_messages.delete_contact_success'),
      )
    }
  }, [isSuccessDelete])

  return {
    isLoadingDelete,
    handleDeleteContact,
  }
}
